<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mt-5">
                <!-- <v-layout class="px-5 pb-8" justify-center align-center>
                  <v-text-field
                    class="mr-3"
                    :disabled="loadingSearch"
                    v-model="searchTextModel"
                    :label="$t('labels.searchAcademy')"
                    v-on:keyup.enter="searchText"
                    hide-details
                    outlined
                    rounded
                  >
                    <template v-slot:append>
                      <v-btn
                        text
                        :loading="loadingSearch"
                        :disabled="searchTextModel.length < 3"
                        color="defaultColor"
                        @click="searchText"
                        class="text-capitalize"
                        style="margin-top: -7px"
                      >
                        {{ $t('buttons.search') }}
                      </v-btn>
                    </template>
                  </v-text-field>

                  <academy-filter-button
                    :showIsAssigned="true"
                    :showSort="false"
                    :showDate="false"
                    :showCategory="false"
                    :showClearAll="false"
                    @filterData="(n) => filterData(n)"
                  />
                </v-layout> 

                <v-divider class="mb-4" /> -->

                <v-layout row wrap class="px-10 justify-center">
                  <v-flex
                    xs12
                    sm12
                    md6
                    lg6
                    xl6
                    v-for="(item, index) in data"
                    :key="index"
                  >
                    <v-card
                      class="mx-auto"
                      style="
                      height: 100%;
                      elevation: 2;
                      shadow-color: #000;
                      shadow-offset: {width: 0, height: 2};
                      shadow-opacity: 0.2;
                      shadow-radius: 2;
                      border-radius: 10px;
                      margin-bottom: 20px;
                      background-color: #fff;
                      "
                      @click="handleItemClick(item)"
                    >
                      <div style="justify-content: center; align-items: center">
                        <img
                          :src="item.Image"
                          alt="Training"
                          style="width: 100%; border-radius: 10px"
                        />
                      </div>
                      <v-card-title style="font-size: 20px; font-weight: bold">
                        {{ item.TrainingName }}
                      </v-card-title>
                      <div
                        class="px-5"
                        v-html="getLimitedDescription(item.Description)"
                      ></div>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout class="px-4" justify-center align-center>
                  <v-subheader class="defaultColor--text">{{
                    computedTitle
                  }}</v-subheader>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingProgress from '../../components/General/LoadingProgress.vue';
import AcademyFilterButton from '../../components/Academy/AcademyFilterButton.vue';
import PostService from '../../services/PostService';
export default {
  data: function () {
    {
      return {
        data: [],
        member: '',
        loadingSearch: false,
        isAssigned: 0,
        searchTextModel: '',
        categoryId: '',
        page: 0,
        pageSize: 99999,
        totalCount: '0',
      };
    }
  },
  components: {
    LoadingProgress,
    AcademyFilterButton,
  },
  mounted() {
    this.member = this.$store.state.username;
    this.categoryId = this.$route.params.id;
    this.isAssigned = this.categoryId === 1 ? 1 : 0;
    console.log('Category ID > ', this.categoryId);
    this.getPosts();
  },
  computed: {
    computedTitle() {
      return this.$t('title.totalCount', { count: this.totalCount });
    },
  },
  methods: {
    getLimitedDescription(description) {
      let words = description.split(' ');

      return words.slice(0, 20).join(' ') + '...';
    },
    handleItemClick(item) {
      console.log(item);
      this.$router.push({
        name: 'training',
        params: {
          Category: item.Category,
          Description: item.Description,
          Duration: item.Duration,
          Image: item.Image,
          RedirectLink: item.RedirectLink,
          TrainingName: item.TrainingName,
        },
      });
    },

    searchText() {
      this.getPosts();
    },

    getPosts() {
      this.loadingSearch = true;
      setPageLoading(true);

      PostService.getVizgoContent(
        this.member,
        this.isAssigned,
        this.searchTextModel,
        this.categoryId,
        this.page,
        this.pageSize
      )
        .then((res) => {
          this.totalCount = res.length;
          this.data = res;
        })
        .catch(async (err) => {
          window.showError(err);
        })
        .then(() => {
          this.loadingSearch = false;
          setPageLoading(false);
        });
    },

    filterData(item) {
      this.isAssigned = item.isAssigned.value;
      this.getPosts();
    },

    loadMore() {
      this.page++;
      this.getPosts();
    },
  },
};
</script>
